export enum Permission {
  DevPortal = 'dev_portal.view',
}
